// Utility function to format dialogue text for plays
export const formatDialogueText = (text) => {
  if (!text) return '';
  
  // Split text into lines
  const lines = text.split('\n');
  const formattedLines = [];
  
  lines.forEach((line, index) => {
    const trimmedLine = line.trim();
    
    // Check if this line is a character name (ends with : and is all caps)
    if (trimmedLine.endsWith(':') && trimmedLine === trimmedLine.toUpperCase() && trimmedLine.length > 1) {
      // Keep the character name with the colon
      const characterName = trimmedLine;
      
      // Add spacing before character name (except for first character)
      if (index > 0) {
        formattedLines.push('<div class="dialogue-spacer"></div>');
      }
      
      // Format character name with special styling
      formattedLines.push(`<div class="character-name">${characterName}</div>`);
    } else if (trimmedLine.length > 0) {
      // This is dialogue text
      formattedLines.push(`<div class="dialogue-text">${trimmedLine}</div>`);
    } else if (trimmedLine.length === 0 && index > 0 && index < lines.length - 1) {
      // Keep single empty lines for natural breaks
      formattedLines.push('<div class="dialogue-break"></div>');
    }
  });
  
  return formattedLines.join('');
};

// Alternative function that returns an array of formatted objects for more control
export const parseDialogueText = (text) => {
  if (!text) return [];
  
  const lines = text.split('\n');
  const dialogueElements = [];
  
  lines.forEach((line, index) => {
    const trimmedLine = line.trim();
    
    if (trimmedLine.endsWith(':') && trimmedLine === trimmedLine.toUpperCase() && trimmedLine.length > 1) {
      // Character name
      const characterName = trimmedLine;
      dialogueElements.push({
        type: 'character',
        content: characterName,
        index
      });
    } else if (trimmedLine.length > 0) {
      // Dialogue text
      dialogueElements.push({
        type: 'dialogue',
        content: trimmedLine,
        index
      });
    } else if (trimmedLine.length === 0 && index > 0 && index < lines.length - 1) {
      // Break
      dialogueElements.push({
        type: 'break',
        content: '',
        index
      });
    }
  });
  
  return dialogueElements;
};
